import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, isRef as _isRef, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "PiramidMethodView" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("計算")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("リセット")
const _hoisted_4 = { class: "PiramidMethodView-Table" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" x ")
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }

import UITitle from "../components/ui/UITitle.vue";
import UIExplain from "../components/ui/UIExplain.vue";
import UIInput from "../components/ui/UIInput.vue";
import UIFlexBox from "../components/ui/UIFlexBox.vue";
import UIButton from "../components/ui/UIButton.vue";
import UIHint from "../components/ui/UIHint.vue";

import { ref, Ref, reactive, computed } from "vue";

type menu = {
	id: string;
	number: number;
	percentage: number;
	count: number;
};


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let weight: Ref<number | any> = ref(null);
Number(weight);

const state = reactive({
	isCalculated: false,
	isCalculateAvailable: false,
	isInterval: false,
	// weight: 0,
});

const calcWeight = (percentage: number) => {
	const result: number = Math.round(Number(weight.value) * (percentage / 100));
	return result;
};

const onClickCalc = () => {
	state.isCalculated = true;
	state.isInterval = true;
};

const onClickReset = () => {
	weight.value = null;
	state.isCalculated = false;
	state.isInterval = false;
};

const isCheckCalculateAvailable = computed(() => {
	return weight.value > 0 && !state.isInterval ? true : false;
});

const isCheckResetAvailable = computed(() => {
	return state.isCalculated ? true : false;
});

const title = "ピラミッド法";
const explain =
	"オーソドックスに着実に筋肥大と筋力アップを目指す場合、ピラミッド法が適しています。";

const menuList: menu[] = [
	{
		id: "1",
		number: 1,
		percentage: 60,
		count: 8,
	},
	{
		id: "2",
		number: 2,
		percentage: 70,
		count: 6,
	},
	{
		id: "3",
		number: 3,
		percentage: 80,
		count: 4,
	},
	{
		id: "4",
		number: 4,
		percentage: 70,
		count: 1000,
	},
	{
		id: "5",
		number: 5,
		percentage: 60,
		count: 1000,
	},
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UITitle, {
      title: title,
      titleType: "normal"
    }),
    _createVNode(UIExplain, { explain: explain }),
    _createVNode(UIInput, {
      modelValue: _unref(weight),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(weight) ? (weight).value = $event : weight = $event)),
      isInterval: _unref(state).isInterval
    }, null, 8, ["modelValue", "isInterval"]),
    _createVNode(UIHint, {
      isCheckCalculateAvailable: _unref(isCheckCalculateAvailable),
      isCheckResetAvailable: _unref(isCheckResetAvailable),
      isInterval: _unref(state).isInterval
    }, null, 8, ["isCheckCalculateAvailable", "isCheckResetAvailable", "isInterval"]),
    _createVNode(UIFlexBox, null, {
      default: _withCtx(() => [
        _createVNode(UIButton, {
          onClick: onClickCalc,
          disabled: !_unref(isCheckCalculateAvailable),
          size: "small"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(UIButton, {
          onClick: onClickReset,
          disabled: !_unref(isCheckResetAvailable),
          size: "small"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }),
    _createElementVNode("table", _hoisted_4, [
      _createElementVNode("tbody", null, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuList, (menu, index) => {
          return _createElementVNode("tr", { key: index }, [
            _createElementVNode("th", null, _toDisplayString(menu.number) + "セット目", 1),
            _createElementVNode("td", null, [
              (!_unref(state).isCalculated)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(menu.percentage) + "%", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(calcWeight(menu.percentage)) + "kg", 1)),
              _hoisted_7,
              (menu.count !== 1000)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(menu.count) + "回", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_9, "限界回数"))
            ])
          ])
        }), 64))
      ])
    ])
  ]))
}
}

})